import * as React from 'react';
import moment from 'lib/momentTimezone';

function checkToday(timezone: string, day?: string): boolean {
    if (!day || !timezone) {
        // we don't know
        return false;
    }
    return moment().tz(timezone).format('YYYY-MM-DD') === day;
}

const REST_OF_DAY_LIMIT = 3600000;

export default function useIsToday(
    timezone: string,
    selectedDay?: string,
): boolean {
    const [isToday, setIsToday] = React.useState(() =>
        checkToday(timezone, selectedDay),
    );

    React.useEffect(() => {
        const newIsTodayValue = checkToday(timezone, selectedDay);
        let handle: undefined | NodeJS.Timeout;

        if (newIsTodayValue) {
            // let's be fancy and make sure we automatically update this value
            // if we're close-ish to the end of the day
            const restOfDay =
                moment().tz(timezone).endOf('day').valueOf() - Date.now();

            if (REST_OF_DAY_LIMIT > restOfDay) {
                handle = setTimeout(() => {
                    handle = undefined;
                    checkToday(timezone, selectedDay);
                }, restOfDay);
            }
        }

        setIsToday(newIsTodayValue);

        return () => {
            if (handle !== undefined) {
                clearTimeout(handle);
            }
        };
    }, [selectedDay, timezone]);

    return isToday;
}
